export default {
    user: {
        // Notifiche quando i permessi dell'utente cambiano
        permissions: 'pica/user/{userId}/permissions/',
        // Notifiche broadcast per forzare aggiornamento permessi per tutti gli utenti
        permissionsAll: 'pica/user/all/permissions/'
    },
    upload: {
        // Global settings stats, for user that has access to all media
        setting: 'pica/upload/settings/{settingsId}/global/',

        pica_service: 'pica/upload/pica_service/{picaServiceId}/global/',

        // Gallery browse photo, we need to know when a new media is created or is processed
        gallery: 'pica/upload/settings/{settingsId}/gallery/{galleryId}/global/',

        // Keep track of new media in the gallery
        // Ci sono nuovi media creati/processati nella gallery aperta, devo chiedere di fornirmi nuovi media
        new_media_gallery: 'pica/upload/settings/{settingsId}/gallery/{galleryId}/task/*/',

        // Keep visible upload task in sync
        // Tengo traccia di tutti gli upload che sto portando avanti ( barra upload )
        user_tasks: 'pica/upload/user/{userId}/task/*/',
    },
    stats: {
        checkin: 'pica/stats/{picaServiceId}/checkin/',
        delivered: 'pica/stats/{picaServiceId}/deliver/'
    }
}